import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getAffiliateStatApi } from '@flipster/apis/v1/affiliate';
import Num from '@flipster/utils/num';

import { authBunja } from '../shared/auth/state';

export const referrerPageBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const affiliateStatsBaseAtom = atomWithQuery((get) => ({
    queryKey: ['getAffiliateStatApi'],
    queryFn: () => getAffiliateStatApi(),
    enabled: get(isCookieLoggedInAtom),
  }));
  const totalRewardAtom = atom((get) => {
    const totalReward = get(affiliateStatsBaseAtom).data?.data.totalReward;
    if (totalReward && Num(totalReward).gte('0.01')) return totalReward;
  });
  const isLoadingAtom = atom((get) => get(affiliateStatsBaseAtom).isLoading);
  return { totalRewardAtom, isLoadingAtom };
});
referrerPageBunja.debugLabel = 'referrerPageBunja';

export const referrerPageSegmentBunja = bunja(() => {
  const { totalRewardAtom } = bunja.use(referrerPageBunja);
  const commonEventPayloadAtom = atom((get) => {
    const totalReward = get(totalRewardAtom);
    return { reward_amount: totalReward ? Number(totalReward) : undefined };
  });
  return { commonEventPayloadAtom };
});
referrerPageSegmentBunja.debugLabel = 'referrerPageSegmentBunja';
